onReady(() => {
    const bulletinBanners = Array.from(document.querySelectorAll('.bulletin-banner'))
    for (const bulletinBanner of bulletinBanners) {
        const ctaButton = bulletinBanner.querySelector('.cta-button')
        ctaButton && ctaButton.addEventListener('click', (event) => dataLayer.push({
            event: 'cta-click',
            interactionType: 'click',
            moduleName: bulletinBanner.dataset.moduleName,
            elementContent: ctaButton.textContent.replace("\n", '')
                .trim(),
            elementType: event.target.nodeName,
            elementClasses: event.target.classList.toString(),
            destinationUrl: event.target.href,
            modulePosition: bulletinBanner.dataset.modulePosition,
            distinctModulePosition: bulletinBanner.dataset.distinctModulePosition,
            moduleTabPosition: bulletinBanner.dataset.tabPosition,
            moduleId: bulletinBanner.dataset.moduleId,
            wpLoggedIn: document.body.classList.contains('logged-in')
                .toString(),
        }))
    }
})
